import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { EasyGiving } from 'components/ui-elements/EasyGiving';

import { CampaignsHomeList } from './CampaignsHomeList';
import { FeaturedSection } from './featured/FeaturedSection';
import { FundraiserSection } from './FundraiserSection';
import { ItemsHomeList } from './ItemsHomeList';

const HomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${theme.maxWidthContainer}px;
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
`;

export const Home = () => {
  return (
    <HomeWrapper>
      <FeaturedSection />
      <HomeContainer>
        <CampaignsHomeList />
        <FundraiserSection />
        <ItemsHomeList />
        <EasyGiving />
      </HomeContainer>
    </HomeWrapper>
  );
};
